{
	"titleFirstPart": "Willkommen bei der",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Gesamt gespeichertes CO₂"
}
